import { render, staticRenderFns } from "./Dictionary.vue?vue&type=template&id=3cc5d4d8&scoped=true&"
import script from "./Dictionary.vue?vue&type=script&lang=js&"
export * from "./Dictionary.vue?vue&type=script&lang=js&"
import style0 from "./Dictionary.vue?vue&type=style&index=0&id=3cc5d4d8&scoped=true&lang=css&"
import style1 from "./Dictionary.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc5d4d8",
  null
  
)

export default component.exports